<template>
  <el-footer class="footerBar flex flex-center" id="footerBar">
    <span style="padding-right: 10px;color:#fff;line-height:20px;">上海中谷物流股份有限公司</span>
    <el-link href="https://beian.miit.gov.cn" target="_blank">
      <span style="padding-right: 10px;color:#fff;line-height:20px;">沪ICP备17036691号-1 </span></el-link>
    <el-link href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502009871" target="_blank">
      <span style="padding-right: 10px;color:#fff;line-height:20px;">沪公网安备 31011502009871号</span></el-link>
    <span></span>
  </el-footer>
</template>
<script>

export default {
  name: 'footerBar',
  data () {
    return {

    }
  },
  methods: {
  },
  mounted () {

  }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/base.scss";
@import "../assets/scss/public.scss";
.footerBar {
  //position:fixed;
  //bottom:0;
  width: 100%;
  height: 54px;
  background: #030b28;
  color: $colorA;
  font-size: $fontE;
  font-weight: 400;
  letter-spacing: 0;
  span {
    margin: 0 10px;
  }
}
</style>